import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./admin.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const NAVBAR_LOGO = "https://customer-assets.emergentagent.com/job_transform-beauty-4/artifacts/gb9lfe95_logo%20son.png";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("aphea_admin_token")) navigate("/admin");
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/auth/admin/login`, { email, password });
      localStorage.setItem("aphea_admin_token", data.token);
      localStorage.setItem("aphea_admin_email", data.email);
      navigate("/admin");
    } catch (err) {
      const status = err.response?.status;
      if (status === 429) {
        setError("Çok fazla deneme yapıldı. Lütfen 1 dakika bekleyin.");
      } else {
        setError(err.response?.data?.detail || "Giriş başarısız. E-posta veya şifre hatalı.");
      }
    }
    setLoading(false);
  };

  return (
    <div className="login-root">
      <div className="login-card">
        <img src={NAVBAR_LOGO} alt="APHEA" className="login-logo" />
        <h1 className="login-title">Yönetim Paneli</h1>
        <p className="login-subtitle">Devam etmek için giriş yapın</p>
        <form onSubmit={handleSubmit} className="login-form">
          <div className="login-field">
            <label className="admin-label">E-posta Adresi</label>
            <input
              type="email"
              className="admin-input"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoComplete="email"
              data-testid="login-email-input"
            />
          </div>
          <div className="login-field">
            <label className="admin-label">Şifre</label>
            <input
              type="password"
              className="admin-input"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              data-testid="login-password-input"
            />
          </div>
          {error && <p className="login-error" data-testid="login-error">{error}</p>}
          <button
            type="submit"
            className="save-btn login-btn"
            disabled={loading}
            data-testid="login-submit-btn"
          >
            {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
          </button>
        </form>
        <a href="/" className="back-link">← Siteye Dön</a>
      </div>
    </div>
  );
}
